import { RawColumn } from '../models';

/**
 * filterHiddenColumns function is used the hide
 * the columns which has hidden as true.
 *
 * @param columns: columns which has to be filtered
 * @returns columns which are not hidden
 */
export const filterHiddenColumns = <T extends Pick<RawColumn, 'hidden'> = RawColumn>(columns: T[]): T[] => {
  return (columns || []).filter(col => !col.hidden);
};
